// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enquiries Page */
.enquiries-page .dashboard-body {
  padding-bottom: 2rem;
}

.enquiries-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}

.enquiries-section {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.enquiries-header {
  padding: 1.25rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.enquiries__title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text, #1e293b);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.enquiries__title i {
  color: #0f766e;
}

.enquiries-btn-refresh {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  font-weight: 600;
  font-family: inherit;
  color: #0f766e;
  background: #fff;
  border: 1px solid #0f766e;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.enquiries-btn-refresh:hover:not(:disabled) {
  background: #0f766e;
  color: #fff;
}

.enquiries-btn-refresh:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.enquiries-filters {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.enquiries-filters__row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-end;
}

.enquiries-filter {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-muted, #64748b);
}

.enquiries-filter input,
.enquiries-select {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  min-width: 180px;
  background: #fff;
}

.enquiries-filter input:focus,
.enquiries-select:focus {
  outline: none;
  border-color: #0f766e;
}

.enquiries-btn-reset {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.enquiries-btn-reset:hover {
  opacity: 0.95;
}

.enquiries-error {
  padding: 1rem 1.5rem;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.enquiries-loading,
.enquiries-empty {
  padding: 3rem 1.5rem;
  text-align: center;
  color: var(--text-muted, #64748b);
}

.enquiries-loading i,
.enquiries-empty i {
  font-size: 2rem;
  display: block;
  margin-bottom: 0.75rem;
  opacity: 0.6;
}

.enquiries-table-wrap {
  overflow-x: auto;
}

.enquiries-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.enquiries-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #f0f9ff;
  background: rgba(15, 23, 42, 0.85);
  white-space: nowrap;
}

.enquiries-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text, #1e293b);
  vertical-align: top;
}

.enquiries-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.enquiries-table tbody tr:hover {
  background: rgba(15, 118, 110, 0.06) !important;
}

.enquiries-name {
  display: block;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.enquiries-contact {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.78rem;
  font-family: inherit;
  color: var(--text-muted, #64748b);
  text-decoration: none;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
}

.enquiries-contact:hover {
  color: #0f766e;
}

.enquiries-contact i {
  width: 12px;
  opacity: 0.7;
}

.enquiries-message {
  max-width: 320px;
  font-size: 0.82rem;
  color: #334155;
  white-space: pre-wrap;
}

.enquiries-date {
  white-space: nowrap;
  font-size: 0.8rem;
  color: var(--text-muted, #64748b);
}

.enquiries-status {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 4px;
  font-size: 0.78rem;
  font-weight: 600;
}

.enquiries-status--new {
  background: #dbeafe;
  color: #1e40af;
}

.enquiries-status--read {
  background: #fef3c7;
  color: #b45309;
}

.enquiries-status--resolved {
  background: #dcfce7;
  color: #166534;
}

.enquiries-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.enquiries-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.7rem;
  font-size: 0.78rem;
  font-weight: 600;
  font-family: inherit;
  border-radius: 6px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.enquiries-action-btn--read {
  color: #b45309;
  background: #fffbeb;
  border-color: #fcd34d;
}

.enquiries-action-btn--read:hover:not(:disabled) {
  background: #fcd34d;
  color: #78350f;
}

.enquiries-action-btn--resolved {
  color: #166534;
  background: #f0fdf4;
  border-color: #86efac;
}

.enquiries-action-btn--resolved:hover:not(:disabled) {
  background: #86efac;
  color: #14532d;
}

.enquiries-action-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .enquiries-filter input,
  .enquiries-select {
    min-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Enquiries/EnquiriesPage.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;EACjC,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Enquiries Page */\n.enquiries-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.enquiries-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n}\n\n.enquiries-section {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.enquiries-header {\n  padding: 1.25rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.enquiries__title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text, #1e293b);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.enquiries__title i {\n  color: #0f766e;\n}\n\n.enquiries-btn-refresh {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  font-size: 0.85rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid #0f766e;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.enquiries-btn-refresh:hover:not(:disabled) {\n  background: #0f766e;\n  color: #fff;\n}\n\n.enquiries-btn-refresh:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.enquiries-filters {\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid #e2e8f0;\n  background: #fff;\n}\n\n.enquiries-filters__row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  align-items: flex-end;\n}\n\n.enquiries-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-muted, #64748b);\n}\n\n.enquiries-filter input,\n.enquiries-select {\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  min-width: 180px;\n  background: #fff;\n}\n\n.enquiries-filter input:focus,\n.enquiries-select:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.enquiries-btn-reset {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.enquiries-btn-reset:hover {\n  opacity: 0.95;\n}\n\n.enquiries-error {\n  padding: 1rem 1.5rem;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.enquiries-loading,\n.enquiries-empty {\n  padding: 3rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted, #64748b);\n}\n\n.enquiries-loading i,\n.enquiries-empty i {\n  font-size: 2rem;\n  display: block;\n  margin-bottom: 0.75rem;\n  opacity: 0.6;\n}\n\n.enquiries-table-wrap {\n  overflow-x: auto;\n}\n\n.enquiries-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.enquiries-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #f0f9ff;\n  background: rgba(15, 23, 42, 0.85);\n  white-space: nowrap;\n}\n\n.enquiries-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text, #1e293b);\n  vertical-align: top;\n}\n\n.enquiries-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.enquiries-table tbody tr:hover {\n  background: rgba(15, 118, 110, 0.06) !important;\n}\n\n.enquiries-name {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.enquiries-contact {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.78rem;\n  font-family: inherit;\n  color: var(--text-muted, #64748b);\n  text-decoration: none;\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n.enquiries-contact:hover {\n  color: #0f766e;\n}\n\n.enquiries-contact i {\n  width: 12px;\n  opacity: 0.7;\n}\n\n.enquiries-message {\n  max-width: 320px;\n  font-size: 0.82rem;\n  color: #334155;\n  white-space: pre-wrap;\n}\n\n.enquiries-date {\n  white-space: nowrap;\n  font-size: 0.8rem;\n  color: var(--text-muted, #64748b);\n}\n\n.enquiries-status {\n  display: inline-block;\n  padding: 0.2rem 0.55rem;\n  border-radius: 4px;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n.enquiries-status--new {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.enquiries-status--read {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.enquiries-status--resolved {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.enquiries-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.enquiries-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.35rem 0.7rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  font-family: inherit;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.enquiries-action-btn--read {\n  color: #b45309;\n  background: #fffbeb;\n  border-color: #fcd34d;\n}\n\n.enquiries-action-btn--read:hover:not(:disabled) {\n  background: #fcd34d;\n  color: #78350f;\n}\n\n.enquiries-action-btn--resolved {\n  color: #166534;\n  background: #f0fdf4;\n  border-color: #86efac;\n}\n\n.enquiries-action-btn--resolved:hover:not(:disabled) {\n  background: #86efac;\n  color: #14532d;\n}\n\n.enquiries-action-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n@media (max-width: 900px) {\n  .enquiries-filter input,\n  .enquiries-select {\n    min-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
